export default __webpack_public_path__ + "ymca-list-icon.svg";